import { render } from "./create-support-case.vue?vue&type=template&id=61bbdff2&scoped=true"
import script from "./create-support-case.vue?vue&type=script&lang=js"
export * from "./create-support-case.vue?vue&type=script&lang=js"

import "./create-support-case.vue?vue&type=style&index=0&id=61bbdff2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bbdff2"]])

export default __exports__